module.exports = __webpack_public_path__ + "static/img/page18.f1eb37d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page18.jpg
// module id = tGm0
// module chunks = 0